import Vue from 'vue'
import {
    Button,
    Image,
    Swipe,
    SwipeItem,
    Lazyload,
    Tab,
    Tabs,
    List,
    Cell,
    Toast,
    Dialog
} from 'vant';
Vue.use(Button).use(Image).use(Swipe).use(SwipeItem).use(Lazyload).use(Tab).use(Tabs).use(List).use(Cell).use(Dialog).use(Toast);
